import styled from '@emotion/styled';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';

interface OverLayerProps {
  isActive?: boolean;
}
export const OverlayeComponent = styled.div<OverLayerProps>`
  background-color: rgba(0, 0, 0, 0.5);
  fill: rgba(0, 0, 0, 0.5);
  position: absolute;
  height: 100%;
  width: calc(100% - 278px);
  z-index: 2;
  top: 0;
  right: 0;
  backdrop-filter: blur(2px);
  display: ${(props) => (props.isActive ? 'block' : 'none')};
  ${mq(BreakpointSizes.xs)} {
    height: calc(100vh - 78px);
    width: 100%;
  }
`;
